import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Wrapper from './styles';
import { useProductsContext } from '../../context/products_context';
import { useUserContext } from '../../context/user_context';
import ReviewStars from '../ReviewStars/';
import Button from '../Button';
import axios from 'axios';

function ReviewModal({ product, setIsAddReview }) {
  const  id   = product;
  const { reviewProduct } = useProductsContext();
  const { currentUser } = useUserContext();
  const [isOpen, setIsOpen] = useState(true);
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    setLoading(true);
    const { success, message } = await reviewProduct(id, stars, comment);
    setIsAddReview(false)
    setLoading(false);
    if (success) {
      return toast.success(message);
    } else {
      return toast.error(message);
    }
  };

  const updateStars = (number) => {
    setStars(number);
  };

  const onOpen = () => {
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const getReviews=async()=>{
   const response = await axios.get(
     `${process.env.REACT_APP_BACKEND_HOST}/api/products/reviews/${id}`
   );
   const reviews = response.data;
   if (reviews && currentUser) {
     const userReview =
       reviews && reviews?.find((rev) => rev.email === currentUser.email);
     if (userReview) {
       setStars(userReview.rating);
       setComment(userReview.comment);
     }
   }
    }
    getReviews()
    
    // eslint-disable-next-line
  }, [product, currentUser]);

  return (
    <Wrapper>
    
      <div className={`${isOpen ? 'modal' : 'modal hide'}`}>
        <div className='form'>
          <ReviewStars stars={stars} updateStars={updateStars} />
          <textarea
            className='input'
            placeholder='your comment'
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            style={{ height: '50px' }}
          />
          {currentUser ? (
            <div className='btn-container'>
              <Button
                disabled={loading}
                className='btn'
                onClick={handleSubmit}
                style={{
                  width: '100%',
                  marginLeft: '10px',
                  height: '50px',
                  backgroundColor: '#d3a143',
                }}
              >
                review
              </Button>
              <button
                className='btn btn-outline'
                onClick={onClose}
                style={{
                  width: '100%',
                  marginLeft: '10px',
                  height: '50px',
                  backgroundColor: '#010535',
                }}
              >
                cancel
              </button>
            </div>
          ) : (
            <div className='btn-container'>
              <Link to='/login' className='btn'>
                login
              </Link>
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
}

export default ReviewModal;
